export { defineConfig, type Config, type PluginConfig } from "../config.js";
